var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useTranslation } from 'react-i18next';
export var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["FR"] = "fr";
    Language["JA"] = "ja";
    Language["RU"] = "ru";
})(Language || (Language = {}));
export function useI18n() {
    var translation = useTranslation();
    function t(key, options) {
        var result = translation.t(key, options);
        return result.includes('::') ? translation.t(key, __assign(__assign({}, options), { lng: Language.EN })) : result;
    }
    return __assign(__assign({}, translation), { t: t });
}
